import { render } from "./Surveys.vue?vue&type=template&id=f12d6916"
import script from "./Surveys.vue?vue&type=script&lang=ts"
export * from "./Surveys.vue?vue&type=script&lang=ts"
script.render = render

export default script